module.exports = __webpack_public_path__ + "static/media/logo-stg1.d13cc7aa.svg";